<template>
  <div class="page-content">
    <page-template
      ref="discountTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>

<script>
  import api from '@/config/api';
  import pageTemplate from '@/components/template/pageTemplate';
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {pageTemplate},
    mounted () {

    },
    created(){
       this.setStore(this.searchOptions.simple);
    },
    data () {
      return {
        searchOptions: {
          simple: [
            {
              label: '门店名称',
              type: 'select',
              data: [],
              prop: 'storeId',
              url: api.system.seStore,
            },
          ],
          complex: [

            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 12,
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              span: 12,
              data: [],
              url: api.archives.supplier,
            },
             {
              label: '选择日期:',
              prop: 'createDttms',
              type: 'datetimeRange',
              dateType: 'date',
              span: 24
            },
          ]
        },
        toolConfig: [
          {
            label: '导出',
            code: 'export',
            callback:this.exportData
          },
        ],
        tableOptions: {
          columns: [
            {label: '序号', prop: 'id', align: 'center'},
            {label: '商品名称', prop: 'code', align: 'center', width: '150',},
            {label: '单数', prop: 'name', align: 'center'},
            {
              label: '商品条码',
              prop: 'status',
              align: 'center',
              width: '150',
              enumData: this.$utils.getCacheStatus('asBrand.status'),
            },
            {label: '规格', prop: 'createBy', align: 'center', width: '150',},
            {label: '单位', prop: 'createDttm', align: 'center', width: '150',},
            {label: '商品类别', prop: 'createDttm', align: 'center', width: '150',},
            {label: '现有库存', prop: 'createBy', align: 'center', width: '150',},
            {label: '销售数量', prop: 'createDttm', align: 'center', width: '150',},
            {label: '商品总售价', prop: 'createDttm', align: 'center', width: '150',},
            {label: '实收金额', prop: 'createBy', align: 'center', width: '150',},
            {label: '实收占比', prop: 'createDttm', align: 'center', width: '150',},
            {label: '利润', prop: 'createDttm', align: 'center', width: '150',},
            {label: '利润率', prop: 'createDttm', align: 'center', width: '150',},
          ],
          url: api.archives.brand,
        },
      };
    },
    methods:{
      exportData(){},
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/report/inventory/Analyse.vue